import { LoadableAfterPaint } from '@confluence/loadable';

export const ByLineForgeApp = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ByLineForgeApp" */ './ByLineForgeApp.tsx'))
			.ByLineForgeApp,
});

export const ContentActionForgeApp = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ContentActionForgeApp" */ './ContentActionForgeApp.tsx'
			)
		).ContentActionForgeApp,
});

export const ContextMenuForgeApp = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ContextMenuForgeApp" */ './ContextMenuForgeApp.tsx'))
			.ContextMenuForgeApp,
});

export const FullPageForgeApp = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-FullPageForgeApp" */ './FullPageForgeApp.tsx'))
			.FullPageForgeApp,
});

export const GlobalPageForgeApp = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-GlobalPageForgeApp" */ './GlobalPageForgeApp.tsx'))
			.GlobalPageForgeApp,
});

export const GlobalSettingsForgeApp = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-GlobalSettingsForgeApp" */ './GlobalSettingsForgeApp.tsx'
			)
		).GlobalSettingsForgeApp,
});

export const HomepageFeedForgeApp = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-HomepageFeedForgeApp" */ './HomepageFeedForgeApp.tsx'))
			.HomepageFeedForgeApp,
});

export const SpaceSettingsForgeApp = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SpaceSettingsForgeApp" */ './SpaceSettingsForgeApp.tsx'
			)
		).SpaceSettingsForgeApp,
});

export const SpacePageForgeApp = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-SpacePageForgeApp" */ './SpacePageForgeApp.tsx'))
			.SpacePageForgeApp,
});

export const CustomContentForgeApp = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-CustomContentForgeApp" */ './CustomContentForgeApp.tsx'
			)
		).CustomContentForgeApp,
});

export const BackgroundScriptForgeApp = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-BackgroundScriptForgeApp" */ './BackgroundScriptForgeApp.tsx'
			)
		).BackgroundScriptForgeApp,
});

export const PageBannerForgeApp = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-PageBannerForgeApp" */ './PageBannerForgeApp.tsx'))
			.PageBannerForgeApp,
});
